import { render } from "./PortalHome.vue?vue&type=template&id=5d826ad6&scoped=true&ts=true"
import script from "./PortalHome.vue?vue&type=script&lang=ts"
export * from "./PortalHome.vue?vue&type=script&lang=ts"

import "./PortalHome.vue?vue&type=style&index=0&id=5d826ad6&scoped=true&lang=css"
import "./PortalHome.vue?vue&type=style&index=1&id=5d826ad6&lang=css"

import exportComponent from "/home/gitlab-deployer/builds/Bp7u02vYG/0/erp/admissibles-front/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d826ad6"]])

export default __exports__